import { getSelectedDisplayProductCode, getSelectedDisplayProductQuery } from 'quick-quote/product-selection/selectors'

import { useSelector, useDispatch } from 'react-redux'
import { Redirect, useLocation } from 'react-router-dom'

import {
  getMarketConductInsuranceQuestionWithChoice,
  getMarketConductRiskQuestionWithChoice,
  isILPProduct,
  isSelectedSavingAndInvestmentNeed,
  isSelectedThirdPartyJoin,
  isSelectedNeverSplittingPremiumFromExpense,
  getReasonForNeverSplittingPremiumFromExpense,
  isNonILPNeedWithInvestmentProduct,
} from './selectors'
import {
  getSuitabilityQuestionaire,
  getSuitabilityAnswers,
  getSuitabilityScore,
  getSuitabilityStatus,
} from '../suitability/selectors'
import { updateSuitabilityAnswer } from '../suitability/actions'
import { setMarketConductQuestion, setReasonForNeverSplittingPremiumFromExpense } from './actions'
import { isFNAPath } from 'quick-quote/components/navigations/utils'
import { getSelectedNeedType } from '../need-and-gap-analysis/selectors'

import { MarketConducts } from './components'
import { getToggles } from '../../feature-toggles'

export const MarketConductsContainer = () => {
  const dispatch = useDispatch()
  const selectedNeedType = useSelector(getSelectedNeedType)
  const riskQuestion = useSelector(getMarketConductRiskQuestionWithChoice)
  const insuranceQuestion = useSelector(getMarketConductInsuranceQuestionWithChoice)
  const productILP = useSelector(isILPProduct)
  const isSelectedThirdPartyJoinValue = useSelector(isSelectedThirdPartyJoin)
  const isSelectedSavingAndInvestmentNeedValue = useSelector(isSelectedSavingAndInvestmentNeed)
  const selectedDisplayProductCode = useSelector(getSelectedDisplayProductCode)
  const selectedDisplayProductQuery = useSelector(getSelectedDisplayProductQuery)
  const isSelectedNeverSplittingPremiumFromExpenseValue = useSelector(isSelectedNeverSplittingPremiumFromExpense)
  const reasonForNeverSplittingPremiumFromExpenseValue = useSelector(getReasonForNeverSplittingPremiumFromExpense)
  const isNonILPNeedWithInvestmentProductValue = useSelector(isNonILPNeedWithInvestmentProduct)
  const suitabilityQuestionaire = useSelector(getSuitabilityQuestionaire)
  const suitabilityAnswers = useSelector(getSuitabilityAnswers)
  const suitabilityScore = useSelector(getSuitabilityScore)
  const suitabilityStatus = useSelector(getSuitabilityStatus)

  const shouldRedirect = () => {
    if (getToggles().ENABLE_FNA_V3) {
      const location = useLocation()
      return isFNAPath(location.pathname) && !selectedNeedType
    }
    return !selectedDisplayProductCode
  }

  if (shouldRedirect()) {
    return <Redirect to="/" push />
  }

  return (
    <MarketConducts
      selectedNeedType={selectedNeedType}
      riskQuestion={riskQuestion}
      insuranceQuestion={insuranceQuestion}
      productILP={productILP}
      isSelectedThirdPartyJoin={isSelectedThirdPartyJoinValue}
      isSelectedSavingAndInvestmentNeed={isSelectedSavingAndInvestmentNeedValue}
      selectedDisplayProductCode={selectedDisplayProductCode}
      selectedDisplayProductQuery={selectedDisplayProductQuery}
      isSelectedNeverSplittingPremiumFromExpense={isSelectedNeverSplittingPremiumFromExpenseValue}
      reasonForNeverSplittingPremiumFromExpense={reasonForNeverSplittingPremiumFromExpenseValue}
      isNonILPNeedWithInvestmentProduct={isNonILPNeedWithInvestmentProductValue}
      suitabilityQuestionaire={suitabilityQuestionaire}
      suitabilityAnswers={suitabilityAnswers}
      suitabilityScore={suitabilityScore}
      suitabilityStatus={suitabilityStatus}
      setMarketConductQuestion={(questionKey, value) => dispatch(setMarketConductQuestion(questionKey, value))}
      setReasonForNeverSplittingPremiumFromExpense={(value) =>
        dispatch(setReasonForNeverSplittingPremiumFromExpense(value))
      }
      updateSuitabilityAnswer={(value) => dispatch(updateSuitabilityAnswer(value))}
    />
  )
}
